//Plantilla de archivo API
let prefix = '/api/componentsCatalogs';

function getComponentsCatalog() {
    return window.axios.get(prefix + '/index');
}
function addComponent(data) {
    return window.axios.post(prefix, data);
}
function updateComponent(id, data) {
    return window.axios.patch(prefix + '/' + id, data);
}
function deleteComponent(id) {
    return window.axios.delete(prefix + '/' + id);
}

export default {
    getComponentsCatalog, addComponent, updateComponent, deleteComponent

}